export default __webpack_public_path__ + "static/media/sdcsh.9056a081.gif";